import React from "react";
import { PortalSetPasswordForm } from "./PortalSetPasswordForm";

export default function PortalResetPassword() {
  return (
    <PortalSetPasswordForm
      title="Redefinir senha"
      subtitle="Escolha uma nova senha para o portal."
      endpoint="/portal/auth/reset-password"
      successMessage="Senha redefinida com sucesso — você já pode entrar."
    />
  );
}
